import * as React from 'react';

const PetsProhibited = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
            transform="matrix(-1 0 0 1 21 1)"
        >
            <circle cx={10} cy={10} r={9.375} />
            <path d="m4.063 17.255 2.838-7.252M11.875 15.626v3.561M8.735 5.24a2.5 2.5 0 0 1 1.89-.865v2.5l4.31 2.154c.423.212.69.645.69 1.119v.477c0 .442-.116.876-.34 1.258M3.371 3.371l13.258 13.258M11.875 16.25l-6.04-3.523" />
        </g>
    </svg>
);
export default PetsProhibited;
